import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import Lottie from 'react-lottie';
import styles from './style.module.scss';
import DefaultContainer from '../DefaultContainer';
import emptyFrame from '../../assets/frames/empty-frame@2x-min.png';


const MobileAnimationSection = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [start1Finished, setStart1Finished] = useState(false);
  const [start2Finished, setStart2Finished] = useState(false);
  const [start3Finished, setStart3Finished] = useState(false);
  const [defaultOptions1Start] = useState({
    loop: false,
    autoplay: true,
    animationData: data[0].start,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });
  const [defaultOptions1Loop] = useState({
    loop: false,
    autoplay: true,
    animationData: data[0].loop,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  const [defaultOptions2Start] = useState({
    loop: false,
    autoplay: true,
    animationData: data[1].start,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  const [defaultOptions2Loop] = useState({
    loop: false,
    autoplay: true,
    animationData: data[1].loop,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  const [defaultOptions3Start] = useState({
    loop: false,
    autoplay: true,
    animationData: data[2].start,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  const [defaultOptions3Loop] = useState({
    loop: false,
    autoplay: true,
    animationData: data[2].loop,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });


  const resize = () => {
    if (window !== 'undefined') {
      setIsMobile(window.innerWidth < 959);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', resize);
      setIsMobile(window.innerWidth < 959);
    }
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <DefaultContainer
      justify="center"
      className={styles.container}
    >
      {
        start1Finished ? (
          <Grid item className={styles.containerGridItem} xs={12} md>
            <img src={emptyFrame} alt="iphone frame" className={styles.frame} />
            <Lottie
              options={defaultOptions1Loop}
              width={isMobile ? 209 : 240}
              eventListeners={[
                {
                  eventName: 'complete',
                  callback: () => setStart1Finished(false),
                },
              ]}
            />
          </Grid>
        ) : (
          <Grid item className={styles.containerGridItem} xs={12} md>
            <img src={emptyFrame} alt="iphone frame" className={styles.frame} />
            <Lottie
              options={defaultOptions1Start}
              width={isMobile ? 209 : 240}
              eventListeners={[
                {
                  eventName: 'complete',
                  callback: () => setStart1Finished(true),
                },
              ]}
            />
          </Grid>
        )
      }
      {
        start2Finished ? (
          <Grid item className={styles.containerGridItem} xs={12} md>
            <img src={emptyFrame} alt="iphone frame" className={styles.frame} />
            <Lottie
              options={defaultOptions2Loop}
              width={isMobile ? 209 : 240}
              eventListeners={[
                {
                  eventName: 'complete',
                  callback: () => setStart2Finished(false),
                },
              ]}
            />
          </Grid>
        ) : (
          <Grid item className={styles.containerGridItem} xs={12} md>
            <img src={emptyFrame} alt="iphone frame" className={styles.frame} />
            <Lottie
              options={defaultOptions2Start}
              width={isMobile ? 209 : 240}
              eventListeners={[
                {
                  eventName: 'complete',
                  callback: () => setStart2Finished(true),
                },
              ]}
            />
          </Grid>
        )
      }
      {
        start3Finished ? (
          <Grid item className={styles.containerGridItem} xs={12} md>
            <img src={emptyFrame} alt="iphone frame" className={styles.frame} />
            <Lottie
              options={defaultOptions3Loop}
              width={isMobile ? 209 : 240}
              eventListeners={[
                {
                  eventName: 'complete',
                  callback: () => setStart3Finished(false),
                },
              ]}
            />
          </Grid>
        ) : (
          <Grid item className={styles.containerGridItem} xs={12} md>
            <img src={emptyFrame} alt="iphone frame" className={styles.frame} />
            <Lottie
              options={defaultOptions3Start}
              width={isMobile ? 209 : 240}
              eventListeners={[
                {
                  eventName: 'complete',
                  callback: () => setStart3Finished(true),
                },
              ]}
            />
          </Grid>
        )
      }
    </DefaultContainer>
  );
};
export default MobileAnimationSection;
